
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/note_v2/templates/display"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='note-displayContent'>\n  <div class='note-displayContentFlexWrapper'>\n    <div class='note-displayContentText'></div>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  